import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "suppliers-page" };
const _hoisted_2 = { class: "page-header" };
const _hoisted_3 = {
    key: 0,
    class: "page-description"
};
const _hoisted_4 = { class: "header-actions" };
const _hoisted_5 = {
    key: 0,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_6 = {
    key: 1,
    class: "notice"
};
const _hoisted_7 = { class: "search-box" };
const _hoisted_8 = {
    key: 0,
    class: "supplier-grid",
    role: "list"
};
const _hoisted_9 = ["onClick", "onKeydown"];
const _hoisted_10 = { class: "supplier-mark" };
const _hoisted_11 = ["src", "alt"];
const _hoisted_12 = { class: "supplier-card-copy" };
const _hoisted_13 = { class: "supplier-code" };
const _hoisted_14 = { class: "supplier-email" };
const _hoisted_15 = ["aria-label", "onClick"];
const _hoisted_16 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_17 = { class: "detail-grid" };
const _hoisted_18 = { class: "supplier-profile panel" };
const _hoisted_19 = { class: "profile-brand" };
const _hoisted_20 = { class: "profile-logo" };
const _hoisted_21 = ["src", "alt"];
const _hoisted_22 = { class: "supplier-code" };
const _hoisted_23 = { class: "contact-list" };
const _hoisted_24 = { class: "contact-row" };
const _hoisted_25 = { class: "contact-row" };
const _hoisted_26 = { class: "contact-row" };
const _hoisted_27 = { class: "contact-row" };
const _hoisted_28 = { class: "contact-row" };
const _hoisted_29 = { class: "contact-row" };
const _hoisted_30 = { class: "profile-flags" };
const _hoisted_31 = { class: "flag-row" };
const _hoisted_32 = { class: "flag-row" };
const _hoisted_33 = { class: "panel data-panel" };
const _hoisted_34 = { class: "panel-header" };
const _hoisted_35 = { class: "panel-count" };
const _hoisted_36 = { class: "table-scroll" };
const _hoisted_37 = { class: "supplier-table" };
const _hoisted_38 = { class: "reference-cell" };
const _hoisted_39 = { class: "numeric" };
const _hoisted_40 = { class: "numeric" };
const _hoisted_41 = { class: "numeric" };
const _hoisted_42 = ["href", "aria-label"];
const _hoisted_43 = {
    key: 1,
    class: "muted"
};
const _hoisted_44 = { key: 0 };
const _hoisted_45 = { class: "panel items-panel" };
const _hoisted_46 = { class: "panel-header" };
const _hoisted_47 = { class: "panel-count" };
const _hoisted_48 = { class: "table-scroll" };
const _hoisted_49 = { class: "supplier-table" };
const _hoisted_50 = { class: "reference-cell" };
const _hoisted_51 = { class: "numeric" };
const _hoisted_52 = { class: "numeric" };
const _hoisted_53 = { key: 0 };
const _hoisted_54 = { class: "form-header" };
const _hoisted_55 = { class: "form-grid" };
const _hoisted_56 = { class: "form-field" };
const _hoisted_57 = { class: "form-field" };
const _hoisted_58 = { class: "form-field" };
const _hoisted_59 = { class: "form-field" };
const _hoisted_60 = { class: "form-field full-field" };
const _hoisted_61 = { class: "form-field" };
const _hoisted_62 = { class: "form-field" };
const _hoisted_63 = { class: "form-field full-field" };
const _hoisted_64 = { class: "toggle-list" };
const _hoisted_65 = { class: "toggle-row" };
const _hoisted_66 = { class: "toggle-row" };
const _hoisted_67 = {
    key: 0,
    class: "notice error-notice",
    role: "alert"
};
const _hoisted_68 = { class: "form-actions" };
const _hoisted_69 = ["disabled"];
const _hoisted_70 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ArrowLeft = _resolveComponent("ArrowLeft");
    const _component_Plus = _resolveComponent("Plus");
    const _component_Search = _resolveComponent("Search");
    const _component_Building2 = _resolveComponent("Building2");
    const _component_Pencil = _resolveComponent("Pencil");
    const _component_Hash = _resolveComponent("Hash");
    const _component_Mail = _resolveComponent("Mail");
    const _component_MapPin = _resolveComponent("MapPin");
    const _component_Phone = _resolveComponent("Phone");
    const _component_FileText = _resolveComponent("FileText");
    const _component_Landmark = _resolveComponent("Landmark");
    const _component_ExternalLink = _resolveComponent("ExternalLink");
    const _component_X = _resolveComponent("X");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("header", _hoisted_2, [
            _createElementVNode("div", null, [
                _cache[18] || (_cache[18] = _createElementVNode("p", { class: "eyebrow" }, "SUPPLIER DIRECTORY", -1)),
                _createElementVNode("h1", null, _toDisplayString(_ctx.selectedSupplier ? _ctx.selectedSupplier.name : 'Suppliers'), 1),
                (_ctx.selectedSupplier)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Supplier profile, invoices, and supplied items."))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
                (_ctx.selectedSupplier)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "secondary-button",
                        type: "button",
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.clearSelection && _ctx.clearSelection(...args)))
                    }, [
                        _createVNode(_component_ArrowLeft, {
                            size: 16,
                            "aria-hidden": "true"
                        }),
                        _cache[19] || (_cache[19] = _createElementVNode("span", null, "All suppliers", -1))
                    ]))
                    : _createCommentVNode("", true),
                (!_ctx.selectedSupplier)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "primary-button",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.openCreateForm && _ctx.openCreateForm(...args)))
                    }, [
                        _createVNode(_component_Plus, {
                            size: 17,
                            "aria-hidden": "true"
                        }),
                        _cache[20] || (_cache[20] = _createElementVNode("span", null, "Add Supplier", -1))
                    ]))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.pageError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.pageError), 1))
            : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading suppliers…"))
                : (!_ctx.selectedSupplier)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("label", _hoisted_7, [
                            _createVNode(_component_Search, {
                                size: 17,
                                "aria-hidden": "true"
                            }),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.searchText) = $event)),
                                type: "search",
                                placeholder: "Search suppliers",
                                "aria-label": "Search suppliers"
                            }, null, 512), [
                                [_vModelText, _ctx.searchText]
                            ])
                        ]),
                        (_ctx.filteredSuppliers.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSuppliers, (supplier) => {
                                    return (_openBlock(), _createElementBlock("article", {
                                        key: supplier.id,
                                        class: "supplier-card",
                                        role: "listitem",
                                        tabindex: "0",
                                        onClick: ($event) => (_ctx.selectSupplier(supplier)),
                                        onKeydown: _withKeys(($event) => (_ctx.selectSupplier(supplier)), ["enter"])
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            (supplier.logoUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: supplier.logoUrl,
                                                    alt: `${supplier.name} logo`
                                                }, null, 8, _hoisted_11))
                                                : (_openBlock(), _createBlock(_component_Building2, {
                                                    key: 1,
                                                    size: 24,
                                                    "aria-hidden": "true"
                                                }))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("h2", null, _toDisplayString(supplier.name), 1),
                                            _createElementVNode("span", _hoisted_13, _toDisplayString(supplier.supplierCode || supplier.id), 1),
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(supplier.email || 'No email added'), 1)
                                        ]),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-pill", supplier.isActive ? 'status-active' : 'status-inactive'])
                                        }, _toDisplayString(supplier.isActive ? 'Active' : 'Inactive'), 3),
                                        _createElementVNode("button", {
                                            class: "icon-button card-edit",
                                            type: "button",
                                            "aria-label": `Edit ${supplier.name}`,
                                            title: "Edit supplier",
                                            onClick: _withModifiers(($event) => (_ctx.openEditForm(supplier)), ["stop"])
                                        }, [
                                            _createVNode(_component_Pencil, {
                                                size: 16,
                                                "aria-hidden": "true"
                                            })
                                        ], 8, _hoisted_15)
                                    ], 40, _hoisted_9));
                                }), 128))
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_Building2, {
                                    size: 21,
                                    "aria-hidden": "true"
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.suppliers.length ? 'No suppliers match your search.' : 'No suppliers yet. Add a supplier to get started.'), 1)
                            ]))
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("section", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        (_ctx.selectedSupplier.logoUrl)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: _ctx.selectedSupplier.logoUrl,
                                                alt: `${_ctx.selectedSupplier.name} logo`
                                            }, null, 8, _hoisted_21))
                                            : (_openBlock(), _createBlock(_component_Building2, {
                                                key: 1,
                                                size: 34,
                                                "aria-hidden": "true"
                                            }))
                                    ]),
                                    _createElementVNode("h2", null, _toDisplayString(_ctx.selectedSupplier.name), 1),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedSupplier.supplierCode || _ctx.selectedSupplier.id), 1)
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_component_Hash, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedSupplier.supplierCode || _ctx.selectedSupplier.id), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _createVNode(_component_Mail, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedSupplier.email || 'No email provided'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _createVNode(_component_MapPin, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedSupplier.address || 'No address provided'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_27, [
                                        _createVNode(_component_Phone, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedSupplier.phone || 'No phone provided'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_28, [
                                        _createVNode(_component_FileText, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, "VAT: " + _toDisplayString(_ctx.selectedSupplier.vatNumber || 'Not provided'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_Landmark, {
                                            size: 16,
                                            "aria-hidden": "true"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedSupplier.bankAccount || 'No bank details provided'), 1)
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "Place stock orders", -1)),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-pill", _ctx.selectedSupplier.canPlaceStockOrder ? 'status-active' : 'status-inactive'])
                                        }, _toDisplayString(_ctx.selectedSupplier.canPlaceStockOrder ? 'Enabled' : 'Disabled'), 3)
                                    ]),
                                    _createElementVNode("div", _hoisted_32, [
                                        _cache[22] || (_cache[22] = _createElementVNode("span", null, "Supplier status", -1)),
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["status-pill", _ctx.selectedSupplier.isActive ? 'status-active' : 'status-inactive'])
                                        }, _toDisplayString(_ctx.selectedSupplier.isActive ? 'Active' : 'Deactivated'), 3)
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    class: "secondary-button edit-profile",
                                    type: "button",
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.openEditForm(_ctx.selectedSupplier)))
                                }, [
                                    _createVNode(_component_Pencil, {
                                        size: 15,
                                        "aria-hidden": "true"
                                    }),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "Edit supplier", -1))
                                ])
                            ]),
                            _createElementVNode("section", _hoisted_33, [
                                _createElementVNode("header", _hoisted_34, [
                                    _cache[24] || (_cache[24] = _createElementVNode("div", null, [
                                        _createElementVNode("p", { class: "eyebrow" }, "DOCUMENT HISTORY"),
                                        _createElementVNode("h2", null, "Supplier Invoices")
                                    ], -1)),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.invoices.length), 1)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("table", _hoisted_37, [
                                        _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "Invoice No."),
                                                _createElementVNode("th", { class: "numeric" }, "Item Quantity"),
                                                _createElementVNode("th", { class: "numeric" }, "Invoice Total"),
                                                _createElementVNode("th", { class: "numeric" }, "Tax Total"),
                                                _createElementVNode("th", null, "Invoice Date"),
                                                _createElementVNode("th", null, "Document")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: invoice.id
                                                }, [
                                                    _createElementVNode("td", _hoisted_38, _toDisplayString(invoice.invoiceNumber || invoice.id), 1),
                                                    _createElementVNode("td", _hoisted_39, _toDisplayString(invoice.itemQuantity ?? '—'), 1),
                                                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatMoney(invoice.invoiceTotal)), 1),
                                                    _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.formatMoney(invoice.taxTotal)), 1),
                                                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(invoice.invoiceDate)), 1),
                                                    _createElementVNode("td", null, [
                                                        (invoice.invoiceUrl)
                                                            ? (_openBlock(), _createElementBlock("a", {
                                                                key: 0,
                                                                class: "document-link",
                                                                href: invoice.invoiceUrl,
                                                                target: "_blank",
                                                                rel: "noopener noreferrer",
                                                                "aria-label": `Open invoice ${invoice.invoiceNumber || invoice.id}`
                                                            }, [
                                                                _createVNode(_component_ExternalLink, { size: 16 })
                                                            ], 8, _hoisted_42))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_43, "—"))
                                                    ])
                                                ]));
                                            }), 128)),
                                            (!_ctx.invoices.length)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, _cache[25] || (_cache[25] = [
                                                    _createElementVNode("td", {
                                                        class: "table-empty",
                                                        colspan: "6"
                                                    }, "No invoices have been added for this supplier.", -1)
                                                ])))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("section", _hoisted_45, [
                            _createElementVNode("header", _hoisted_46, [
                                _cache[27] || (_cache[27] = _createElementVNode("div", null, [
                                    _createElementVNode("p", { class: "eyebrow" }, "CATALOGUE"),
                                    _createElementVNode("h2", null, "Supplier Items")
                                ], -1)),
                                _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.supplierItems.length), 1)
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("table", _hoisted_49, [
                                    _cache[29] || (_cache[29] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "Item ID"),
                                            _createElementVNode("th", null, "Description"),
                                            _createElementVNode("th", { class: "numeric" }, "Qty in stock"),
                                            _createElementVNode("th", { class: "numeric" }, "Stock Value (Incl.)"),
                                            _createElementVNode("th", null, "Last Placed Date")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplierItems, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: item.id
                                            }, [
                                                _createElementVNode("td", _hoisted_50, _toDisplayString(item.itemId || item.id), 1),
                                                _createElementVNode("td", null, _toDisplayString(item.description || '—'), 1),
                                                _createElementVNode("td", _hoisted_51, _toDisplayString(item.quantityInStock ?? 0), 1),
                                                _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.formatMoney(item.stockValue)), 1),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.lastPlacedDate)), 1)
                                            ]));
                                        }), 128)),
                                        (!_ctx.supplierItems.length)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_53, _cache[28] || (_cache[28] = [
                                                _createElementVNode("td", {
                                                    class: "table-empty",
                                                    colspan: "5"
                                                }, "No supplier items have been added yet.", -1)
                                            ])))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ])
                    ], 64)),
        (_ctx.formOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: "modal-backdrop",
                onClick: _cache[17] || (_cache[17] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)), ["self"]))
            }, [
                _createElementVNode("form", {
                    class: "supplier-form",
                    onSubmit: _cache[16] || (_cache[16] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.saveSupplier && _ctx.saveSupplier(...args)), ["prevent"]))
                }, [
                    _createElementVNode("header", _hoisted_54, [
                        _createElementVNode("div", null, [
                            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "eyebrow" }, "SUPPLIER PROFILE", -1)),
                            _createElementVNode("h2", null, _toDisplayString(_ctx.editingSupplierId ? 'Edit Supplier' : 'Add Supplier'), 1)
                        ]),
                        _createElementVNode("button", {
                            class: "icon-button",
                            type: "button",
                            "aria-label": "Close form",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                        }, [
                            _createVNode(_component_X, { size: 19 })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("label", _hoisted_56, [
                            _cache[31] || (_cache[31] = _createElementVNode("span", null, "Supplier name *", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.form.name) = $event)),
                                required: "",
                                maxlength: "120"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.name,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_57, [
                            _cache[32] || (_cache[32] = _createElementVNode("span", null, "Supplier ID", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.supplierCode) = $event)),
                                maxlength: "80"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.supplierCode,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_58, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", null, "Email", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.email) = $event)),
                                type: "email",
                                maxlength: "160"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.email,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_59, [
                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "Phone number", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.form.phone) = $event)),
                                type: "tel",
                                maxlength: "60"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.phone,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_60, [
                            _cache[35] || (_cache[35] = _createElementVNode("span", null, "Address", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.form.address) = $event)),
                                rows: "2",
                                maxlength: "300"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.address,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_61, [
                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "VAT number", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.form.vatNumber) = $event)),
                                maxlength: "80"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.vatNumber,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_62, [
                            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Bank account", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.form.bankAccount) = $event)),
                                maxlength: "120"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.bankAccount,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_63, [
                            _cache[38] || (_cache[38] = _createElementVNode("span", null, "Logo URL", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.form.logoUrl) = $event)),
                                type: "url",
                                placeholder: "https://",
                                maxlength: "500"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.form.logoUrl,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("label", _hoisted_65, [
                            _cache[39] || (_cache[39] = _createElementVNode("span", null, "Can place stock orders", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.form.canPlaceStockOrder) = $event)),
                                type: "checkbox"
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.form.canPlaceStockOrder]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_66, [
                            _cache[40] || (_cache[40] = _createElementVNode("span", null, "Supplier is active", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.form.isActive) = $event)),
                                type: "checkbox"
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.form.isActive]
                            ])
                        ])
                    ]),
                    (_ctx.formError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_67, _toDisplayString(_ctx.formError), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("footer", _hoisted_68, [
                        _createElementVNode("button", {
                            class: "secondary-button",
                            type: "button",
                            disabled: _ctx.saving,
                            onClick: _cache[15] || (_cache[15] =
                                //@ts-ignore
                                (...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                        }, "Cancel", 8, _hoisted_69),
                        _createElementVNode("button", {
                            class: "primary-button",
                            type: "submit",
                            disabled: _ctx.saving
                        }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.saving ? 'Saving…' : 'Save Supplier'), 1)
                        ], 8, _hoisted_70)
                    ])
                ], 32)
            ]))
            : _createCommentVNode("", true)
    ]));
}
